"use strict";
// Copyright 2019-2022 Unique Network (Gibraltar) Ltd.
// This file is part of Unique Network.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.rmrk = exports.unique = void 0;
// Unique Network is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
// Unique Network is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
// You should have received a copy of the GNU General Public License
// along with Unique Network. If not, see <http://www.gnu.org/licenses/>.
var definitions_1 = require("./unique/definitions");
Object.defineProperty(exports, "unique", { enumerable: true, get: function () { return __importDefault(definitions_1).default; } });
var definitions_2 = require("./rmrk/definitions");
Object.defineProperty(exports, "rmrk", { enumerable: true, get: function () { return __importDefault(definitions_2).default; } });
var definitions_3 = require("./default/definitions");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(definitions_3).default; } });
//# sourceMappingURL=definitions.js.map